import variable from "./../variables/platform";

export default (variables = variable) => {
  // fills its parent instead of a height measured once at start up,
  // so the layout follows the size of the window
  const theme = {
    flex: 1,
  };

  return theme;
};
